import React from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useState, useEffect, useContext } from "react";
import { Collapse } from "bootstrap";
import { SetAllContext } from "../../services/AllContext";
import "./TopBar.css";
import BankeLogo from "../../assets/BankeMainLogo.png";

const TopBar = () => {
  const { userID } = useContext(SetAllContext);
  // Functions
  const toggleNavbar = () => {
    const navbar = document.getElementById("navbarNav");
    const bsCollapse =
      Collapse.getInstance(navbar) || new Collapse(navbar, { toggle: false });
    navbar.classList.contains("show") ? bsCollapse.hide() : bsCollapse.show();
  };
  // JS
  const navigate = useNavigate();
  const location = useLocation();
  const [activeLink, setActiveLink] = useState(location.pathname);
  const handleSetActive = (link) => {
    setActiveLink(link);
  };
  useEffect(() => {
    setActiveLink(location.pathname);
  }, [location.pathname]);
  useEffect(() => {
    const navbar = document.getElementById("navbarNav");
    const links = navbar.querySelectorAll("a.nav-link");

    const handleLinkClick = () => {
      const bsCollapse = Collapse.getInstance(navbar);
      if (bsCollapse) bsCollapse.hide();
    };

    links.forEach((link) => link.addEventListener("click", handleLinkClick));

    // cleanup on unmount
    return () => {
      links.forEach((link) =>
        link.removeEventListener("click", handleLinkClick)
      );
    };
  }, []);

  // HTML
  return (
    <nav className="navbar navbar-expand-lg navbar-light bg-light sticky-top">
      <div className="container">
        <Link className="navbar-brand" to="/">
          <img src={BankeLogo} alt={"Banke Logo"} />
        </Link>
        <button
          className="navbar-toggler"
          type="button"
          aria-controls="navbarNav"
          aria-expanded="false"
          aria-label="Toggle navigation"
          onClick={toggleNavbar}
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className="collapse navbar-collapse" id="navbarNav">
          {/* 1 */}
          <ul className="navbar-nav ms-auto">
            <li className="nav-item">
              <Link
                className={`nav-link ${
                  activeLink === "/home" ? "active" : null
                } `}
                onClick={() => handleSetActive("/")}
                to="/home"
              >
                Home
              </Link>
            </li>
            <li className="nav-item">
              <Link
                className={`nav-link ${
                  activeLink === "/vendors" ? "active" : null
                } `}
                onClick={() => handleSetActive("/vendors")}
                to="/vendors"
              >
                Vendors
              </Link>
            </li>
            <li className="nav-item">
              <Link
                className={`nav-link ${
                  activeLink === "/shop" || activeLink === "/" ? "active" : null
                } `}
                onClick={() => handleSetActive("/shop")}
                to="/shop"
              >
                Shop
              </Link>
            </li>
            <li className="nav-item">
              <Link
                className={`nav-link ${
                  activeLink === "/faq" ? "active" : null
                } `}
                onClick={() => handleSetActive("/faq")}
                to="/faq"
              >
                FAQ
              </Link>
            </li>
            <li className="nav-item">
              <Link
                className={`nav-link ${
                  activeLink === "/contact" ? "active" : null
                } `}
                onClick={() => handleSetActive("/contact")}
                to="/contact"
              >
                Contact Us
              </Link>
            </li>
          </ul>
          {/* 2 */}
          <ul className="navbar-nav ms-4">
            <li className="nav-item">
              <Link
                className={`nav-link ${
                  activeLink === "/profile" ? "active" : null
                } `}
                onClick={() => handleSetActive("/profile")}
                to="/profile"
              >
                <i className="fa-regular fa-user"></i>
              </Link>
            </li>
            <li className="nav-item">
              <Link
                className={`nav-link ${
                  activeLink === "/profile/wishlist" ? "active" : null
                } `}
                onClick={() => handleSetActive("/profile/wishlist")}
                to="/profile/wishlist"
              >
                <i className="fa-regular fa-heart"></i>
              </Link>
            </li>
            <li className="nav-item">
              <Link
                className={`nav-link ${
                  activeLink === "/cart" ? "active" : null
                } `}
                onClick={() => handleSetActive("/cart")}
                to="/cart"
              >
                <i className="fa-solid fa-cart-shopping"></i>
              </Link>
            </li>
          </ul>
          {/* 3 */}
          <ul className="navbar-nav ms-4 top-bar-button">
            {userID === null ? (
              <button
                onClick={() => navigate("/auth/login")}
                className="btn btn-primary"
              >
                Log in
              </button>
            ) : (
              <button
                className="btn btn-primary"
                onClick={() => navigate("/profile/affiliate-market")}
              >
                Affiliate
              </button>
            )}
            <button
              className="btn btn-outline-primary"
              onClick={() => navigate("/profile/vendor-signup")}
            >
              Become a Vendor
            </button>
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default TopBar;
